import { createRoot } from 'react-dom/client';
import { lazy, Suspense } from 'react';
import App from './App';
import { LocalEnvironmentSwitcher } from './features/local-environment';
import { AuthApp } from './features/auth/AuthApp';
import { AuthDesignPreview } from './features/auth/AuthDesignPreview';
import { DesignPreviewApp } from './features/design-v2/DesignPreviewApp';
import { authPathOf } from './features/auth/auth-paths';
import './lib/styles/tokens.css';
import './lib/styles/base.css';
import './lib/styles/flow.css';
import './features/design-v2/shared-surfaces.css';

declare const __LOCAL_ENVIRONMENT_ENABLED__: boolean;

// Auth screens render without loading the session or workspace data.
const authPath = authPathOf(location.pathname);
const authDesignPreview = new URLSearchParams(location.search).get('design') === 'v2';
const isolatedDesignPreview = new URLSearchParams(location.search).get('preview') === 'design-v2';
const liquidPreview = new URLSearchParams(location.search).get('preview') === 'remotion-liquid';
const RemotionMotionPreview = lazy(() => import('./pages/remotion-motion-preview'));
createRoot(document.getElementById('app')!).render(<>{liquidPreview ? <Suspense fallback={<p>Loading animation…</p>}><RemotionMotionPreview /></Suspense> : isolatedDesignPreview ? <DesignPreviewApp /> : <>{__LOCAL_ENVIRONMENT_ENABLED__ && !authPath && <LocalEnvironmentSwitcher />}{authPath ? (authDesignPreview ? <AuthDesignPreview path={authPath} /> : <AuthApp path={authPath} />) : <App />}</>}</>);
